import {
  useEffect, useCallback, useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import telemetryActions from '@state/telemetry/actions';

function useMapForVehicle() {

  const dispatch = useDispatch();
  const history = useHistory();
  const allDevices = useSelector(({ telemetry: tel }) => tel.allDevices);

  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState(allDevices);
  const [filterDevices, setFilterDevices] = useState(allDevices);

  const getDevices = () => {

    setLoading(false);
    setDevices(allDevices);
    setFilterDevices(allDevices);

  };

  useEffect(() => {

    if (allDevices) {

      getDevices();

    }

  }, [allDevices]);

  const goToDeviceId = useCallback((device) => {

    // eslint-disable-next-line
    if (device?.business_type?.name.trim() === 'Retail' || device?.business_type?.name.trim() === 'Almacenamiento') {

      dispatch(telemetryActions.setDeviceId(device.id));
      history.push(`/tablero-general/almacenamiento/${device.id}`);

    } else {

      dispatch(telemetryActions.setDeviceId(device.id));
      history.push(`/tablero-general/${device.id}`);

    }

    // eslint-disable-next-line
   }, []);

  const onChangeDevices = (e) => {

    if (!e.target.checked) {

      setFilterDevices(devices.filter((device) => !device?.gateway?.latitude));

    } else {

      setFilterDevices(devices);

    }

  };

  return {
    goToDeviceId, devices, onChangeDevices, loading, filterDevices,
  };

}

export default useMapForVehicle;
